import React from 'react';
import {Link} from '@sail/ui';
import {deprecatedCss, view} from '@sail/engine';

const basic = {
  rendered: (
    <view.div uses={[deprecatedCss`layout: row; gap: $spacing-xl;`]}>
      <Link>Primary link</Link>
      <Link type="secondary">Secondary link</Link>
    </view.div>
  ),
  source: `<Link>Primary link</Link>
<Link type="secondary">Secondary link</Link>`,
};

const primary = {
  rendered: <Link>Primary link</Link>,
  source: `<Link>Primary link</Link>`,
};

const secondary = {
  rendered: <Link type="secondary">Secondary link</Link>,
  source: `<Link type="secondary">Secondary link</Link>`,
};

const disabled = {
  rendered: (
    <view.div uses={[deprecatedCss`layout: row; gap: $spacing-xl;`]}>
      <Link disabled href="https://google.com" target="_href">
        Primary link
      </Link>
      <Link type="secondary" disabled href="https://google.com" target="_href">
        Secondary link
      </Link>
    </view.div>
  ),
  source: `<Link disabled>Primary link</Link>
<Link type="secondary" disabled>Secondary link</Link>`,
};

const newTab = {
  rendered: (
    <Link href="https://google.com" target="_href">
      Open link in new tab
    </Link>
  ),
  source: `<Link href="https://google.com" target="_href">
  Open link in new tab
</Link>`,
};

export const LinkExamples = {basic, primary, secondary, disabled, newTab};
